import {LOGIN} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/Login.vue'),
    name: LOGIN,
    path: 'login',
    meta: {
        name: LOGIN,
        title: '登录'
    }
};